var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMatch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "251.183px",
    height: "191.319px",
    viewBox: "0 0 251.183 191.319",
    enableBackground: "new 0 0 251.183 191.319",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_MATCH"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4_MATCH",
    display: "none"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_MATCH"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_MATCH"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M238.149,168.543         c-4.919,0.126-7.931-1.099-9.808-6.629c-1.485-4.354-9.491-9.588-15.078,3.238l-10.252,23.534l-84.346-36.741l11.45-26.284         c5.587-12.826,13.593-7.593,15.077-3.238c1.878,5.53,4.89,6.755,9.809,6.629c5.551-0.146,15.005-15.465,9.229-21.612         c-4.091-4.356-11.134,0.32-15.854-1.79c-4.261-1.912-5.481-9.326-4.027-12.663l11.457-26.303l35.426,15.431         c3.327,1.45,10.75,0.211,12.666-4.037c2.109-4.72-2.563-11.773,1.794-15.863c6.147-5.775,21.471,3.669,21.613,9.229         c0.125,4.919-1.112,7.937-6.633,9.818c-4.355,1.484-9.593,9.5,3.233,15.087l16.246,7.076l-12.656,29.054         c-1.453,3.337-0.232,10.751,4.028,12.662c4.72,2.111,11.764-2.566,15.854,1.791C253.154,153.078,243.7,168.397,238.149,168.543z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M122.116,116.908         c-4.92,0.125-7.931-1.099-9.81-6.629c-1.484-4.354-9.49-9.588-15.077,3.238l-10.251,23.534l-18.08-7.876         c-3.328-1.449-10.764-0.205-12.674,4.057c-2.107,4.711,2.566,11.763-1.795,15.863c-6.147,5.774-21.471-3.671-21.611-9.229         c-0.127-4.92,1.115-7.945,6.636-9.827c4.354-1.484,9.597-9.509-3.229-15.096L2.632,100.311l15.044-34.535         c5.587-12.826,13.593-7.593,15.077-3.239c1.878,5.531,4.89,6.756,9.809,6.63c5.551-0.146,15.005-15.465,9.229-21.613         c-4.091-4.356-11.134,0.32-15.854-1.79c-4.261-1.911-5.481-9.325-4.028-12.662l7.864-18.052l84.345,36.74l-12.655,29.054         c-1.454,3.337-0.233,10.751,4.027,12.662c4.721,2.11,11.764-2.566,15.855,1.79C137.121,101.443,127.666,116.763,122.116,116.908z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M92.867,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M79.821,29.949"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M62.571,26.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M92.226,39.248"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMatch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/match.3e291948.svg";
export { ForwardRef as ReactComponent };